

















































































































































































































































































import api from "@/getinfo-api";
import { Vue, Component, Watch, Ref } from "vue-property-decorator";
import { AxiosError } from "axios";
import { CourseLecture as ICourseLecture } from "@/api/models/course-lecture";
import { CourseLectureShort as ICourseLectureShort } from "@/api/models/course-lecture-short";
import { Course as ICourse } from "@/api/models/course";
import { CourseLectureShortList as ICourseLectureShortList } from "@/api/models/course-lecture-short-list";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import AssignTestToEntity from "@/components/tests/AssignTestToEntity.vue";
import SlideView from "@/components/slides/SlideView.vue";
import LectureVideoView from "@/components/slides/LectureVideoView.vue";
import LectureExtraMaterialView from "@/components/slides/LectureExtraMaterialView.vue";
import LectureTextView from "@/components/slides/LectureTextView.vue";
import { FormattedLectureSort } from "@/plugins/tree";
import {
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId,
  getCurrentEmployee
} from "@/plugins/roles";
import {
  CourseProgress as ICourseProgress,
  CourseProgressStatusEnum
} from "@/api/models/course-progress";
import { CourseLectureProgress as ICourseLectureProgress } from "@/api/models/course-lecture-progress";
import { CourseTestPassProgress as ICourseTestPassProgress } from "@/api/models/course-test-pass-progress";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({
  components: {
    TextField,
    LectureVideoView,
    AssignTestToEntity,
    SlideView,
    LectureExtraMaterialView,
    LectureTextView
  }
})
export default class LecturesView extends Vue {
  @Ref("content_block") contentBlock?: HTMLElement;
  courseLectureInfo!: ICourseLectureShort | ICourseLecture | undefined;
  allLectures: Array<ICourseLectureShort> = [];
  nextLecture!: ICourseLecture | undefined;
  prevLecture!: ICourseLecture | undefined;
  parentCourse!: ICourse | undefined;
  showTestSettings: boolean = false;
  progress!: ICourseProgress;

  data() {
    return {
      courseLectureInfo: undefined,
      owner: undefined,
      nextLecture: undefined,
      prevLecture: undefined,
      parentCourse: undefined,
      progress: undefined
    };
  }

  get status() {
    return CourseProgressStatusEnum;
  }

  get isHasAccessToIntermediateTest() {
    const checkByProgress = this.progress?.status === this.status.Learning;
    return (
      this.testId &&
      this.courseLectureInfo?.test?.intermediateTest &&
      checkByProgress
    );
  }

  get userIsHasCompany() {
    return !!getCurrentCompanyId();
  }

  get _canEditLecture() {
    return this.root || this.companyOwner || this.employee;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.userId === this.parentCourse?.company.owner.id;
  }

  get employee() {
    return !!getCurrentEmployee();
  }

  async getProgressByListener() {
    let listenerIdByCourse = await api.CourseApi.listenerGetActiveByUser(
      this.$route.params.courseId,
      this.userId
    );

    try {
      if (listenerIdByCourse.data) {
        const listenerId = listenerIdByCourse.data.id;

        const listenerProgressResponse = await api.CourseApi.listenerProgress(
          this.$route.params.courseId,
          listenerId
        );
        this.progress = listenerProgressResponse.data;
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  get checkSuccessTest() {
    const checkCurrentLectureProgress = (el: ICourseLectureProgress) => {
      return el.id === this.$route.params.courseLectureId;
    };

    const curr = this.progress
      ? this.progress?.lectures?.find(checkCurrentLectureProgress)
      : undefined;

    const findSuccessTest = (el: ICourseTestPassProgress) => {
      return el.success === true;
    };

    return curr ? curr.test?.pass?.find(findSuccessTest) : undefined;
  }

  scrollToTop() {
    this.$nextTick(() => {
      const blockTop = this.contentBlock?.offsetTop;
      window.scrollTo({
        top: blockTop,
        behavior: "smooth"
      });
    });
  }

  getInformationAboutCourseLecture() {
    this.showTestSettings = false;
    api.CourseLectureApi.getShort(
      this.$route.params.courseId,
      this.$route.params.courseLectureId
    )
      .then((res: { data: ICourseLectureShort }) => {
        this.courseLectureInfo = res.data;
        document.title =
          this.courseLectureInfo.lecture?.title ?? document.title;
        if (res.data) {
          api.CourseApi.get(this.$route.params.courseId)
            .then((response: { data: ICourse }) => {
              this.parentCourse = response.data;
            })
            .catch(
              (
                error: AxiosError<IErrorResponse | IValidationErrorResponse>
              ) => {
                if (error.response) {
                  this.$bvToast.toast(error.response.data.message, {
                    variant: "danger",
                    title: "Error"
                  });
                }
              }
            );
        }
      })
      .catch((error: AxiosError<IErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(error.response.data.message, {
            variant: "danger",
            title: "Error"
          });
        }
      });
  }

  get testId() {
    return this.courseLectureInfo && this.courseLectureInfo.test
      ? this.courseLectureInfo.test.id
      : undefined;
  }

  created() {
    this.getInformationAboutCourseLecture();
    this.getProgressByListener();
  }

  // Важно отметить, что при переходе от /user/foo к /user/bar будет повторно использован тот же самый экземпляр
  // компонента. Поскольку оба маршрута указывают на один и тот же компонент - это означает, что хуки жизненного цикла
  // компонента при этом вызываться не будут. Поэтому пришлось использовать метод-наблюдатель за роутом,
  // и при изменение вызывать методы используемые при инициализации страницы

  @Watch("$route")
  refreshGetInformationAboutCourseLecture() {
    this.prevLecture = undefined;
    this.nextLecture = undefined;
    this.courseLectureInfo = undefined;
    this.getInformationAboutCourseLecture();
  }

  initSortedLecture() {
    if (this.courseLectureInfo) {
      let sortedLecture = new FormattedLectureSort(
        this.allLectures as any,
        this.courseLectureInfo as any
      );
      this.nextLecture = sortedLecture.nextLecture;
      this.prevLecture = sortedLecture.prevLecture;
    }
  }

  @Watch("courseLectureInfo")
  getPrevAndNextLecture() {
    if (this.courseLectureInfo) {
      api.CourseLectureApi.listShort(this.$route.params.courseId).then(
        (res: { data: ICourseLectureShortList }) => {
          this.allLectures = res.data.lectures;
          this.initSortedLecture();
        }
      );
    } else {
      return undefined;
    }
  }
}
